module.exports = __webpack_public_path__ + "static/media/mobileScreenshot07.fb4b6da1.jpg";